<template>
    <div class="mt-4 mb-2 ml-3">
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Date:
            </div>
            <div>{{ row.date | time }}</div>
        </div>
        <div class="layout row mb-2" v-if="row.processedDate">
            <div class="font-weight-medium mr-1 width-200">
                Processed Date:
            </div>
            <div>{{ row.processedDate | time }}</div>
        </div>
        <div class="layout row mb-2" v-if="row.dateCreated">
            <div class="font-weight-medium mr-1 width-200">
                Date Created:
            </div>
            <div>{{ row.dateCreated | time }}</div>
        </div>

        <div
            class="layout row mb-2"
            v-if="row.userName && row.userName != 'Anonymous'"
        >
            <div class="font-weight-medium mr-1 width-200">User:</div>
            <div>{{ row.userName }}</div>
        </div>
        <div class="layout row mb-2" v-if="row.status == 'ERROR'">
            <div class="font-weight-medium mr-1 width-200">Error Message:</div>
            <div class="text-danger">{{ row.transactionResult }}</div>
        </div>
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Imported:
            </div>
            <div>{{ row.isImported ? "Yes" : "No" }}</div>
        </div>

        <div class="layout row mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <div class="mt-5" v-if="row.details || row.scheduleDetails">
            <div class="font-weight-medium mb-2 layout row">
                Payment Details
            </div>
            <div
                class="layout row mb-2"
                v-for="detail in getPaymentDetails(row.details)"
                v-if="row.details || row.scheduleDetails"
            >
                <div class="font-weight-medium mr-1">
                    {{ detail.category }}:
                </div>
                <div>${{ detail.amount }}</div>
            </div>
        </div>

        <div class="mt-5" v-if="row.refunds">
            <div class="font-weight-medium mb-2 layout row">Refunds</div>
            <div class="layout row mb-2" v-for="detail in getRefundDetails()">
                <div class="font-weight-regular mr-2">{{ detail.date }}:</div>
                <div class="text-danger">${{ detail.amount }}</div>
            </div>
        </div>

        <div
            class="layout row mb-2"
            v-if="
                !hideReversePayment() &&
                    row.status == 'PROCESSED' &&
                    row.tranType == 'Sale'
            "
        >
            <v-btn small dark color="default" @click="reversePayment"
                >Reverse Payment</v-btn
            >
        </div>

        <div
            class="layout row mb-2"
            v-if="
                (row.status == 'DECLINED' || row.status == 'ERROR') &&
                    (row.tranType == 'Sale' || !row.tranType)
            "
        >
            <v-btn small color="success" @click="confirmDialog = true"
                >Process Again</v-btn
            >
        </div>

        <v-dialog persistent v-model="confirmDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">Are you sure?</div>
                <div class="my-3">
                    This will reprocess the payment of
                    {{ row.amount | currency }}
                </div>
                <v-card-actions class="pb-0 mr-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="confirmDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="processAgain()"
                        >Confirm</v-btn
                    >
                </v-card-actions></v-card
            >
        </v-dialog>

        <v-dialog persistent v-model="reversePaymentDialog" max-width="400">
            <reverse-payment
                :closeDialog="closeReversePaymentDialog"
                :payment="paymentToReverse"
                :reloadPage="reloadGrid"
                :details="paymentToReverseDetails"
            ></reverse-payment>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import reversePayment from "../Account/ReversePayment.vue";
import { toTitleCase, except, sum } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            paymentToReverse: {
                details: [],
            },

            confirmDialog: false,

            reversePaymentDialog: false,
            paymentToReverseDetails: [],

            categories: new Map([
                ["TC", "Tuition"],
                ["TRNS", "Transportation"],
                ["LAPC", "Lapidus"],
            ]),
        };
    },
    components: {
        reversePayment,
    },
    async created() {},
    computed: {},
    methods: {
        getPaymentDetails() {
            if (!this.row.details && !this.row.scheduleDetails) return;

            const details = this.row.details
                ? this.row.details
                : this.row.scheduleDetails;

            return details.split("|").map((detail) => {
                const category = detail.split(":")[0];
                const amount = detail.split(":")[1];

                return {
                    category: this.getCategoryName(category),
                    amount,
                };
            });
        },
        getCategoryName(category) {
            return category == "TC"
                ? "Tuition"
                : category == "TRNS"
                ? "Transportation"
                : category;
        },
        getRefundDetails() {
            if (!this.row.refunds) return;

            return this.row.refunds.split("|").map((detail) => {
                const date = this.formatTime(detail.split(",")[0]);
                const amount = detail.split(",")[1];

                return {
                    date,
                    amount,
                };
            });
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "userName",
                    "details",
                    "refunds",
                    "date",
                    "scheduleDetails",
                    "isImported",
                    "processedDate",
                    "dateCreated"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        hideReversePayment() {
            return [
                "LapidusPayments",
                "YKPayments",
                "YKPaymentDetails",
            ].includes(this.$route.name);
        },
        canReverse(payment) {
            return (
                payment.status == "PROCESSED" &&
                !["Refund", "Void"].includes(payment.transactionType)
            );
        },
        getReverseOnAccountMessage() {
            var source = this.row.source || "";
            var details = this.row.details || this.row.scheduleDetails || "";
            var categories = this.row.categories || "";

            if (
                source == "LAPIDUS" ||
                details.indexOf("LAPC") >= 0 ||
                details.indexOf("LPDC") >= 0 ||
                details.indexOf("LAPD") >= 0 ||
                categories.indexOf("LAPC") >= 0 ||
                categories.indexOf("LPDC") >= 0 ||
                categories.indexOf("LAPD") >= 0
            ) {
                return "Void this payment from the Lapidus account page (Refund/Void Payment), not from Payments. Reversing here voids the card but does not create the void transaction.";
            }

            if (
                source == "YKC" ||
                details.indexOf("YKC") >= 0 ||
                categories.indexOf("YKC") >= 0
            ) {
                return "Void this payment from the YK account page (Refund/Void Payment), not from Payments. Reversing here voids the card but does not create the void transaction.";
            }

            if (
                source == "GIRLSCAMP" ||
                details.indexOf("GIRC") >= 0 ||
                categories.indexOf("GIRC") >= 0
            ) {
                return "Void this payment from the Girls Camp account page (Refund/Void Payment), not from Payments. Reversing here voids the card but does not create the void transaction.";
            }

            return "";
        },
        reversePayment() {
            var reverseOnAccountMessage = this.getReverseOnAccountMessage();

            if (this.$route.name == "Payments" && reverseOnAccountMessage) {
                this.$notify({
                    group: "notification",
                    text: reverseOnAccountMessage,
                    type: "error",
                });
                return;
            }

            if (!this.row.details && !this.row.scheduleDetails) return;

            const details = this.row.details
                ? this.row.details
                : this.row.scheduleDetails;

            this.paymentToReverse = JSON.parse(JSON.stringify(this.row));

            let paymentToReverseDetails = details
                .split("|")
                .map((detail) => {
                    const category =
                        this.categories.get(detail.split(":")[0]) ||
                        detail.split(":")[0];
                    const amount = detail.split(":")[1];

                    if (!+amount) return false;

                    return {
                        category,
                        amount,
                        maxAmount: +amount,
                    };
                })
                .filter(Boolean);

            if (
                paymentToReverseDetails.some(
                    (d) => d.category == "Transportation"
                )
            ) {
                paymentToReverseDetails.find(
                    (d) => d.category == "Transportation"
                ).category = "Tuition";
            }

            const tuition = paymentToReverseDetails.filter(
                (p) => p.category == "Tuition"
            );
            const other = paymentToReverseDetails.filter(
                (p) => p.category != "Tuition"
            );

            if (
                tuition &&
                tuition.length &&
                tuition.some((t) => +t.amount > 0)
            ) {
                other.push({
                    category: "Tuition",
                    amount: sum(tuition.map((t) => +t.amount)),
                    maxAmount: sum(tuition.map((t) => +t.maxAmount)),
                });
            }

            this.paymentToReverse.details = other;

            this.reversePaymentDialog = true;
        },
        closeReversePaymentDialog() {
            this.reversePaymentDialog = false;
        },
        async processAgain() {
            let data = {};

            if (
                this.categoryCode == "YKC" ||
                this.categoryCode == "LAPC" ||
                this.categoryCode == "LPDC"
            ) {
                data = {
                    user: this.$store.state.authentication.user,
                    scheduleDetailID,
                };
            } else {
                data = {
                    payment: this.row,
                    user: this.$store.state.authentication.user,
                };
            }

            let url = "api/payments/processAgain";

            if (this.categoryCode == "YKC") {
                url = "api/yk/processAgain";
            }

            if (this.categoryCode == "LAPC" || this.categoryCode == "LPDC") {
                url = "api/lapidusDayCamp/processAgain";
            }

            const response = await this.$http.post(url, data);

            this.$notify({
                text: "Payment " + response.transactionResult,
                group: "notification",
                type: response.resultCode == "A" ? "success" : "Error",
            });

            this.reloadGrid();
        },
        viewSchedule() {
            this.$router.push({
                name: "AccountView",
                params: {
                    id: this.row.accountID,
                },
                query: {
                    schedule: this.row.scheduleDetailId,
                },
            });
        },
        viewPayment() {
            this.$router.push({
                name: "Account View",
                params: {
                    id: this.row.accountID,
                },
                query: {
                    payment: this.row.paymentID.toString(),
                },
            });
        },
    },
};
</script>
<style></style>
